<template>
  <ComponentDetailSubCategory v-if="$route.name === 'detailSubcategory'"></ComponentDetailSubCategory>
  <router-view v-else></router-view>
</template>

<script>
import ComponentDetailSubCategory from "@/components/subCategory/ComponentDetailSubCategory";
import {pages} from "../../vue.config";

export default {
  name: "DetailCategoryView",
  components: {ComponentDetailSubCategory},
  props: {
    prova: {
      type: String
    }
  },
  setup() {
    return {}
  },
  data() {
    return {}
  },
  created() {

  },
  mounted() {
    document.title = 'Dettaglio sottocategoria' + ' | ' + pages.index.title
  }
}
</script>

<style scoped>

</style>